import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Schedule from '../views/Schedule.vue'
import Event from '../views/Event.vue'
import Goods from '../views/Goods.vue'
import Guide from '../views/Guide.vue'
import Present from '../views/Present.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    props: { "ch": "maisy" },
    name: "maisy",
    meta: {
      title: 'ジュエルステージ「オンエア！」～Unit Story side MAISY',
    }
  },
  {
    path: '/maisy',
    component: Home,
    props: { "ch": "maisy" },
    name: "maisy",
    meta: {
      title: 'ジュエルステージ「オンエア！」～Unit Story side MAISY',
    }
  },
  {
    path: '/schedule',
    component: Schedule,
    name: "schedule",
    meta: {
      title: 'ジュエルステージ「オンエア！」～Unit Story MxRxE',
    }
  },
  {
    path: '/event',
    component: Event,
    name: "event",
    meta: {
      title: 'ジュエルステージ「オンエア！」～Unit Story MxRxE',
    }
  },
  {
    path: '/goods',
    component: Goods,
    props: { "ch": "goods" },
    name: "goods",
    meta: {
      title: 'ジュエルステージ「オンエア！」～Unit Story MxRxE グッズページ'
    }
  },
  {
    path: '/guide',
    component: Guide,
    props: { "ch": "guide" },
    name: "guide",
    meta: {
      title: 'ジュエルステージ「オンエア！」～Unit Story MxRxE 公演に関するお知らせ'
    }
  },
  {
    path: '/present/:key',
    component: Present,
    props: { "ch": "present" },
    name: "present",
    meta: {
      title: 'ジュエルステージ「オンエア！」～Unit Story MxRxE 壁紙ダウンロード'
    }
  },
  {
    path: '/refly',
    component: Home,
    props: { "ch": "refly" },
    name: "refly",
    meta: {
      title: 'ジュエルステージ「オンエア！」～Unit Story side Re:Fly'
    }
  },
  {
    path: '/emekare',
    component: Home,
    props: { "ch": "emekare" },
    name: "emekare",
    meta: {
      title: 'ジュエルステージ「オンエア！」～Unit Story side エメ☆カレ'
    }
  }
]
// testのときは base: '/onairtest/mre',
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  // Get the page title from the route meta data that we have defined
  // See further down below for how we setup this data
  document.querySelector('body').classList.remove('modal-wait');
  const title = to.meta.title
  const desc = title + '上演決定！'
  const urlHead = 'https://onair-stage.com/mre/'
  const urlFolder = '/mre/'
  const url = urlHead + to.name
  const icon = `${urlHead}img/icon/${to.name}_ogp.jpg`
  // If the route has a title, set it as the page title of the document/page
  if (title) {
    document.title = title
    document.querySelector('meta[name="description"]').setAttribute("content", desc)
    document.querySelector('meta[property="og:title"]').setAttribute("content", title)
    document.querySelector('meta[property="og:description"]').setAttribute("content", desc)
    document.querySelector('meta[property="og:url"]').setAttribute("content", url)
    document.querySelector('meta[property="og:image"]').setAttribute("content", icon)
    document.querySelector('meta[name="twitter:image"]').setAttribute("content", icon)
    document.querySelector('meta[property="og:site_name"]').setAttribute("content", title)
    document.querySelector('meta[name="twitter:title"]').setAttribute("content", title)
    document.querySelector('meta[name="twitter:description"]').setAttribute("content", desc)
    
    let head = document.querySelector("head")
    let favicons = [{ 'id': 'apple','rel': 'apple-touch-icon', 'href': `${urlFolder}img/icon/${to.name}_favicon.png`, 'sizes': '192x192' }, {'id':'icon-s', 'rel': 'icon', 'href': `${urlFolder}img/icon/${to.name}_favicon_s.png`, 'sizes': '128x128' }, {'id':'icon', 'rel': 'icon', 'href': `${urlFolder}img/icon/${to.name}_favicon.png`, 'sizes': '192x192' },]
    
    let oldCanonical = document.querySelector('link[rel="canonical');
    if (oldCanonical) {
      document.head.removeChild(oldCanonical);
    }
    let links = document.createElement('link');
    links.setAttribute('rel', 'canonical');
    links.setAttribute('href', url);
    head.appendChild(links);

    favicons.forEach(function (icon) {
      let oldLink = document.getElementById(icon.id);
      if (oldLink) {
        document.head.removeChild(oldLink);
      }
      let links = document.createElement('link');
      links.setAttribute('rel', icon.rel);
      links.setAttribute('sizes', icon.sizes);
      links.setAttribute('href', icon.href);
      links.setAttribute('id', icon.id);
      head.appendChild(links);
    })
  }
  // Continue resolving the route
  next()
})

export default router
